import { RoleUI } from '../types/interfaces';

export const RolesTemplate: RoleUI = {
  id: 0,
  name: '',
  displayName: '',
  description: ''
};
